import { useMutation, useQueryClient } from "react-query";
import { deleteSalesLead } from "../../../../../actions/Utilities/SalesLead";
import { toast } from "../../../../../components/toastNotification";

export default function useDisableSalesLead() {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids: number[]) => deleteSalesLead(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["SalesLead"]);
      toast.fire(
        "Success",
        "Sales Lead were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Sales Lead failed",
        "Server Error: Cannot deactivate Sales Lead",
        "error"
      );
    },
  });

  return mutate;
}
